<div class="access-code-container">
  <goab-form-item [label]="label" [error]="displayErrorMessage">
    <goab-input
      name="access-code"
      [formControl]="itemFormCtrl"
      [value]="itemFormCtrl.value"
      (keydown.enter)="verifyCode()"
      data-cy="accessCode-input"
    ></goab-input>
  </goab-form-item>

  <br />
  <goab-button
    (onClick)="verifyCode()"
    [disabled]="!itemFormCtrl.value || itemFormCtrl.value.trim() === '' || disableAccessCodeSubmit"
    data-cy="accessCode-button"
  >
    {{ buttonText }}
  </goab-button>

  <div *ngIf="accessCodeVerified">
    <br /><goab-callout type="success">
      <span>{{ successMessage }}</span>
    </goab-callout>
  </div>
</div>
